<template>
    <div class="logout"></div>
</template>
<script>
import * as api from "@/script/apiService/api.js"
export default {
    name: 'logout',
    async beforeMount(){
        await api.postLogout();
        this.$store.commit({
            type: "setUserInfo",
            userInfo: null
        })
        this.$router.push(`${process.env.VUE_APP_PACACLOUND_ROOT}/login`);
    }
}
</script>